import generateUtilityClasses from '@mui/material/generateUtilityClasses';
import { baseSelectButtonClasses } from '../BaseSelectButton/baseSelectButtonClasses';

const baseSelectClasses = generateUtilityClasses('AFSelect', [
  'labelWrapper',
  'selectButtonText',
  'appIcon'
]);

export const selectClasses = {
  ...baseSelectButtonClasses,
  ...baseSelectClasses
};
